import React, { createContext, useState } from 'react';

import { useContextSafe } from 'helpers/utils';
import { useHistory } from 'stores/hooks';

import { ApiClient } from './codegen/api';
import middlewares from './middlewares';

const ApiContext = createContext<ApiClient | null>(null);
const useApi = () => useContextSafe(ApiContext);

type ApiProviderProps = {
  children: React.ReactNode;
};

function ApiProvider({ children }: ApiProviderProps) {
  const history = useHistory();

  const [api] = useState(
    () =>
      new ApiClient({
        baseUrl: `${window.location.origin}/api/internal/private`,
        middlewares: [
          new middlewares.AddCsrfHeaderMiddleware(),
          new middlewares.TrackRequestIdMiddleware(),
          new middlewares.HandleErrorsMiddleware(history, window.appState.lang),
        ],
        getHeaders: () => ({
          'Accept-Language': window.appState.lang,
          'Content-Type': 'application/json',
          'X-Retino-Frontend': window.appState.bundleHash,
        }),
      }),
  );

  return <ApiContext.Provider value={api}>{children}</ApiContext.Provider>;
}

export { ApiContext, ApiProvider };
export default useApi;
